import React from "react";
import createIcon from "../icon/create_icon.png";


const CornerButton = ({ onClick }) => {

  return (
    <div
      id="cornerButton"
      className="w3-button corner-btn"
      onClick={onClick} // Optional click handler
    >
      <img id="create_icon" src={createIcon} alt="Create" width="33" height="33" />
    </div>
  );
};

export default CornerButton;
